import { createWebHistory, createRouter } from "vue-router";
import Main from "../sites/Main.vue";
import Conversation from "../sites/Conversation.vue";

import Phase1 from "../components/Phase1.vue";
import Phase2 from "../components/Phase2.vue";
import Phase3 from "../components/Phase3.vue";
import TrigendaInfo from "../components/TrigendaInfo.vue";
import ContactInfo from "../components/ContactInfo.vue";

// C import Register from "../components/Register.vue";

// C import Login from "../components/Login.vue"
import Home from "../components/Home.vue"
import ChooseDeck from "../components/ChooseDeck.vue";

const routes = [
    {
        path: "/trigenda",
        redirect: "/",
    },
    {
        path: "/",
        name: "Main",
        component: Main,
    },
    {
        path: "/conversation",
        name: "Conversation",
        component: Conversation,
    },
    {
        path: "/phase1",
        name: "Phase1",
        component: Phase1,
    },
    {
        path: "/phase2",
        name: "Phase2",
        component: Phase2,
    },
    {
        path: "/phase3",
        name: "Phase3",
        component: Phase3,
    },
    {
        path: "/trigendainfo",
        name: "TrigendaInfo",
        component: TrigendaInfo,
    },
    {
        path: "/contactinfo",
        name: "ContactInfo",
        component: ContactInfo
    },

    /* {
        path: "/register",
        name: "Register",
        component: Register
    },
    {
        path: "/login",
        name: "Login",
        component: Login
    }, */
    {
        path: "/home",
        name: "Home",
        component: Home,
        meta: { requiresAuth: true }
    },
    {
        path: "/choosedeck",
        name: "ChooseDeck",
        component: ChooseDeck,
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    // If route has a guard . . .
    if(to.meta.requiresAuth) {
        // Check if user haven't logged in. If they aren't they are moved to login page
    }

    else next();
});

export default router;